// Status + priority badge styling for the Swiss/high-contrast theme.
import { cn } from "../lib/utils";

const STATUS_STYLES = {
  Registered: "bg-gray-100 text-gray-800 border-gray-300",
  Assigned: "bg-klein text-white border-klein",
  "In Progress": "bg-[#0A0A0A] text-white border-[#0A0A0A]",
  Resolved: "bg-emerald-600 text-white border-emerald-600",
  Closed: "bg-gray-200 text-gray-700 border-gray-400",
  "Revisit Required": "bg-warn text-ink border-warn",
  "Customer Not Responding": "bg-orange-100 text-orange-800 border-orange-300",
  "Awaiting Parts": "bg-purple-100 text-purple-800 border-purple-300",
  Reopened: "bg-signal text-white border-signal",
};

const PRIORITY_STYLES = {
  Low: "bg-gray-100 text-gray-700 border-gray-300",
  Medium: "bg-blue-50 text-klein border-klein/40",
  High: "bg-orange-100 text-orange-800 border-orange-400",
  Urgent: "bg-signal text-white border-signal",
};

export function StatusBadge({ status, className }) {
  return (
    <span
      data-testid={`status-badge-${status?.replace(/\s+/g, "-").toLowerCase()}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 text-xs font-bold uppercase tracking-wide border",
        STATUS_STYLES[status] || "bg-gray-100 text-gray-800 border-gray-300",
        className
      )}
    >
      {status}
    </span>
  );
}

export function PriorityBadge({ priority, className }) {
  return (
    <span
      data-testid={`priority-badge-${priority?.toLowerCase()}`}
      className={cn(
        "inline-flex items-center px-2 py-0.5 text-xs font-bold uppercase tracking-wide border",
        PRIORITY_STYLES[priority] || "bg-gray-100 text-gray-700 border-gray-300",
        className
      )}
    >
      {priority}
    </span>
  );
}
